import React, {useState} from "react";
import LayoutDialog from "@/components/layout/layout-dialog";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Field } from "@/components/form";
import {useTheme} from "@mui/material/styles";
import PStars from "./p-stars";
import {useAddCommentMutation} from "@/redux/apis";
import {LoadingButton} from "@mui/lab";
import Label from "@/components/form/label";
import Stack from "@mui/material/Stack";

export default function PCommentDialog({
                                           open,
                                           handleClose,
                                           setSelectedStars,
                                           selectedStars,
                                           mutateProduct,
                                           productId
                                       }: {
    productId: number,
    open: boolean;
    handleClose: () => void;
    mutateProduct: () => void;
    selectedStars: number | undefined;
    setSelectedStars: (selectedStars: number) => void;
}) {
    const theme = useTheme()
    const [text, setText] = useState("")
    const [addComment, {isLoading}] = useAddCommentMutation()

    const onSubmit = () => {
        addComment({productId, body: text, stars: selectedStars || 0})
            .unwrap()
            .then(() => {
                handleClose();
                setText("");
                setSelectedStars(0);
                mutateProduct();
            });
    }


    return (
        <LayoutDialog
            title = "ثبت نظر"
            open = {open}
            handleClose = {handleClose}
            maxWidth = "xs"
            dialogActions = {
                <Stack width = '100%' spacing = {2} direction = "row" >
                    <Button
                        onClick = {handleClose}
                        fullWidth
                        variant = "outlined"
                    >
                        لغو
                    </Button >

                    <LoadingButton
                        loading = {isLoading}
                        onClick = {onSubmit}
                        disableElevation
                        fullWidth
                        disabled = {!selectedStars}
                        variant = "contained"
                        color = "secondary"
                    >
                        تایید
                    </LoadingButton >

                </Stack >

            }
        >
            <Box display = "flex" justifyContent = "center" width="100%">
                <PStars
                    onClick = {(i) => {
                        setSelectedStars(i);
                    }}
                    fixedRating = {selectedStars}
                    fontSize={28}
                />
            </Box >

            <Box
                display = "flex" mt = {2}
                justifyContent = "center"
                sx = {{
                    "& fieldset": {
                        border: 1,
                        borderColor: theme.palette.grey[300],
                    },
                }}
            >
                <Box width = {400} >
                        <Label >نظر خود را بنویسید:</Label >
                        <Field.Text
                            sx = {{height: "unset"}}
                            placeholder = "اینجا بنویسید..."
                            rows = {10}
                            multiline
                            fullWidth
                            value = {text}
                            onChange = {(e) => setText(e.target.value)}
                            type = "text"
                        />

                </Box >
            </Box >
        </LayoutDialog >
    );
}
